import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('div',{class:'sammio__modal ' + (_vm.showModal ? 'sammio__modal--visible' : 'sammio__modal--hidden') + ' sammio__modal--' + _vm.getType + ' ' + _vm.getPointer,attrs:{"id":_vm.id}},[_c(VCard,[_c(VCardTitle,[_vm._t("content")],2),_c(VCardActions,[_vm._t("actions")],2)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }